import { render, staticRenderFns } from "../templates/normal_fcont_190.html?vue&type=template&id=44dd5e06&scoped=true&"
import script from "./normal_fcont_190.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_190.vue?vue&type=script&lang=js&"
import style0 from "./normal_fcont_190.vue?vue&type=style&index=0&id=44dd5e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd5e06",
  null
  
)

export default component.exports